export function HsyItemsService (
  $q,
  $translate,
  API,
  sessionObjAPI,
) {
  var HsyItems = function (customer, vehicle, type) {
    this.origin   = sessionObjAPI.base().origin;
    this.vehicle  = vehicle  || {};
    this.customer = customer || {};
    this.type     = type; // 'event' or 'invoice'
  };

  HsyItems.prototype.buildQuery = function (record) {
    const self = this;

    var queryString = {
      hookUrl   : self.getHookUrl(record),
      orderno   : record.job_card_number,
      quoteref  : record.hsy_quote_number,
      return_url: `${API.url}/${ this.type === 'invoice' ? 'invoices' : 'events' }/add_item_from_hsy/${record.id}`
    };

    queryString[ this.type === 'invoice' ? 'invoice_id' : 'event_id' ] = record.id;

    if (self.vehicle.id) {
      let build_year  = self.vehicle.build_date;
      let build_month = '';

      if (self.vehicle.build_date && self.vehicle.build_date.match('/')) {
        build_year  = self.vehicle.build_date.split('/')[1];
        build_month = self.vehicle.build_date.split('/')[0];
      }

      queryString.action     = 'quote';
      queryString.buildmonth = build_month ;
      queryString.buildyear  = build_year;
      queryString.keywords   = self.vehicle.model;
      queryString.rego       = self.vehicle.plate_number;
      queryString.state      = self.vehicle.plate_state;
      queryString.vin        = self.vehicle.vin;
    }
    else {
      return $q.reject($translate.instant('JS_SPACE.MESSAGES.MUST_ATTACH_VEHICLE_TO_INVOICE'));
    }

    return $q.when($.param(queryString));
  };

  HsyItems.prototype.getHookUrl = function (record) {
    const self = this;

    return self.vehicle && self.vehicle.id ?
    `${self.origin}workshop.html#/${self.customer.id}/${self.vehicle.id}/${this.type}/${record.id}` :
    `${self.origin}workshop.html#/${self.customer.id}/${this.type}/${record.id}`;
  };

  HsyItems.prototype.getPortalUrl = function(record) {
    const self = this;

    return self.buildQuery(record)
    .then(queryString => `/hsy.html?${queryString}`);
  };

  return HsyItems;
}
